import React, { useEffect, useState } from "react";
import validator from "validator";
import { Alert, Form } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";

import { NavLink, useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import DetailsModal from "../Common/DetailsModal";

// import Header from "../Header/Header";
import { NavData } from "../Header/NavData";
import Header from "../Header/NewHeader";
import { getAllPartners, createPartner } from "../../api/axios";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { showToast } from "../../Utills/toast";
import FormGroup from "../Common/FormGroup";
import PhoneNumberInput from "../Common/PhoneInput/PhoneNumberInput";
import { IoEyeOffSharp, IoEyeSharp } from "react-icons/io5";
import LoadingDots from "../Common/LoadingDots/LoadingDots";

const initialFormState = {
  first_name: "",
  last_name: "",
  email: "",
  phone_number: "",
  password: "",
  confirmPassword: "",
  sub_domain: "",
  logo: null,
  is_white_labelled: false,
  membership_prefix: "",
  group_namenum: ""
};

// Validation Schema
const validationSchema = Yup.object().shape({
  first_name: Yup.string()
    .trim()
    .required("First name is required."),
  last_name: Yup.string()
    .trim()
    .required("Last name is required."),
  email: Yup.string()
    .email("A valid email is required.")
    .required("Email is required."),
  phone_number: Yup.string(),
  password: Yup.string()
    .min(8, "Password must be at least 8 characters long.")
    .required("Password is required."),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], "Passwords do not match.")
    .required("Confirm password is required."),
  sub_domain: Yup.string()
    .trim()
    .required("Subdomain is required."),
  membership_prefix: Yup.string()
    .trim()
    .required("Membership prefix is required."),
  group_namenum: Yup.string()
    .trim()
    .required("Group name is required."),
  logo: Yup.mixed()
    .required("Logo is required."),
  is_white_labelled: Yup.boolean()
});

export default function Sidebar() {
  const { partnerId } = useParams();
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(false);

  const [dialogOpen, setDialogOpen] = useState(false);

  const [open, setOpen] = useState(false);
  const [dropdownData, setDropdownData] = useState();
  const [selectedPartnerId, setSelectedPartnerId] = useState(0);
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  useEffect(() => {
    if (partnerId) {
      setSelectedPartnerId(partnerId);
    }
  }, [partnerId]);

  const fetchAllPartner = async () => {
    try {
      setLoading(true);
      const response = await getAllPartners();
      const partnerData = response?.data?.data;

      let dropdownData = partnerData?.map((partner) => {
        return { title: partner?.sub_domain, value: partner?.id };
      });

      setDropdownData(dropdownData);
    } catch (error) {
      showToast({
        type: 'error',
        message: error?.response?.data?.message || 'Something went wrong! Please try again later',
      });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchAllPartner();
  }, []);

  const ButtonItem = [
    {
      name: "Yes",
      onClick: () => {
        localStorage.clear();
        setOpen(false);
        navigate("/");
      },
    },
    {
      name: "No",
      onClick: () => {
        setOpen(false);
      },
    },
  ];

  const handleClose = () => {
    setOpen(!open);
  };

  const handleSelectChange = (e) => {
    const { value } = e.target;
    console.log("options", value);
    if (!value || value === "0") {
      navigate(`/home`);
      return;
    }
    if (value === "insert") {
      setDialogOpen(true);
      return;
    }
    setSelectedPartnerId(value);
    navigate(`/${value}/general-settings`);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleFormSubmit = async (values, { setSubmitting, setFieldError, resetForm }) => {
    const formDataToSend = new FormData();

    // Append each field from values to formDataToSend
    for (const key in values) {
      if (values[key] !== null && values[key] !== undefined) {
        formDataToSend.append(key, values[key]);
      }
    }

    setSaving(true);
    setSubmitting(true);

    try {
      const res = await createPartner(formDataToSend);

      if (res.status === 200) {
        handleDialogClose();
        resetForm();
        showToast({
          type: 'success',
          message: res?.data?.message || 'Partner created successfully!',
        });
        // Refresh the dropdown data
        fetchAllPartner();
      }
    } catch (err) {
      setFieldError('general', 
        err?.response?.data?.message ||
        "Something went wrong! Please try again later"
      );
    } finally {
      setSaving(false);
      setSubmitting(false);
    }
  };
  
  return (
    <>
      <Wrapper className="scroll3">
        <Top>
          <NavLink>
            <Image>
              <img
                src={require("../../Assets/pawprint-icon.png")}
                alt="logo"
                style={{
                  borderBottom: "1px solid white",
                  paddingLeft: "20px",
                }}
              />
            </Image>
          </NavLink>
        </Top>
        <Box component="div" sx={{margin: "10px 13px" }}>
        <SelectBox
          onChange={(e) => {
            const { value } = e.target;
            if (value === "insert") {
              setDialogOpen(true); 
              e.target.value = partnerId || 0;
            } else {
              handleSelectChange(e);
            }
          }}
        >
          <option value={0} selected={false}>
                {loading ? (
                  <>
                    Fetching partners
                    <LoadingDots speed={200} maxDots={3} color="inherit" size="inherit" />
                  </>
                ) : (
                  "Select the partner"
                )}
          </option>
          {dropdownData?.map((option, index) => (
            <option
              style={{backgroundColor:'#FFF'}}
              key={index}
              value={option.value}
              selected={option.value === Number(selectedPartnerId)}
            >
              {option?.title}
            </option>
          ))}
          <option key={"insert"} value={"insert"} selected={false}>
            + Add Partner
          </option>
        </SelectBox>
        </Box>

        {partnerId && (
          <MenuWrapper>
            {NavData.map((item, index) => (
              <NavLink
                to={`/${partnerId}${item.link}`}
                activeClassName="active"
                key={index}
                // style={item?.icon ? { justifyContent: "start" } : {}}
              >
                <MenuItem>
                  <h1 style={{ margin: "0px", padding: "10px" }}>
                    {item.title}
                  </h1>
                </MenuItem>
              </NavLink>
            ))}
          </MenuWrapper>
        )}
        <MenuWrapper style={{ paddingTop: "0px" }}>
          <MenuItem onClick={() => setOpen(true)}>
            <h1 style={{ margin: "0px", padding: "10px" }}>Log Out</h1>
          </MenuItem>
        </MenuWrapper>

        <DetailsModal
          label="Do you want to logout?"
          open={open}
          buttonList={ButtonItem}
          severity="warning"
          handleClose={handleClose}
        />
      </Wrapper>
      <Header />

      <Dialog open={dialogOpen} onClose={handleDialogClose} fullWidth size="md">
        <DialogTitle>Add New Partner</DialogTitle>
        <DialogContent>
          <Formik
            initialValues={initialFormState}
            validationSchema={validationSchema}
            onSubmit={handleFormSubmit}
          >
            {({
              values,
              errors,
              touched,
              handleSubmit,
              setFieldValue,
              isSubmitting,
              getFieldProps,
            }) => (
              <form onSubmit={handleSubmit}>
                <FormGroup label="First Name" error={touched.first_name && errors.first_name} requiredField>
                  <Form.Control
                    {...getFieldProps('first_name')}
                    type="text"
                    placeholder="Enter First Name"
                  />
                </FormGroup>

                <FormGroup label="Last Name" error={touched.last_name && errors.last_name} requiredField>
                  <Form.Control
                    {...getFieldProps('last_name')}
                    type="text"
                    placeholder="Enter Last Name"
                  />
                </FormGroup>

                <FormGroup label="Email" error={touched.email && errors.email} requiredField>
                  <Form.Control
                    {...getFieldProps('email')}
                    type="email"
                  />
                </FormGroup>

                <FormGroup label="Phone Number">
                  <PhoneNumberInput
                    label='Phone Number'
                    name="phone_number"
                    value={values.phone_number}
                    error={touched.phone_number && !!errors.phone_number}
                    onChange={(value, country) => {
                      setFieldValue('phone_number', value);
                    }}
                  />
                </FormGroup>

                <FormGroup label="Password" error={touched.password && errors.password} requiredField>
                  <div style={{ position: 'relative' }}>
                    <Form.Control
                      {...getFieldProps('password')}
                      type={showPassword ? "text" : "password"}
                    />
                    <button
                      type="button"
                      style={{
                        right: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: '14px'
                      }}
                      className="w-auto m-0 cursor-pointer position-absolute"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <IoEyeOffSharp size={20} /> : <IoEyeSharp size={20} />}
                    </button>
                  </div>
                </FormGroup>

                <FormGroup label="Confirm Password" error={touched.confirmPassword && errors.confirmPassword} requiredField>
                  <div style={{ position: 'relative' }}>
                    <Form.Control
                      {...getFieldProps('confirmPassword')}
                      type={showConfirmPassword ? "text" : "password"}
                    />
                    <button
                      type="button"
                      style={{
                        right: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'none',
                        border: 'none',
                        fontSize: '14px',
                      }}
                      className="w-auto m-0 cursor-pointer position-absolute"
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    >
                      {showConfirmPassword ? <IoEyeOffSharp size={20} /> : <IoEyeSharp size={20} />}
                    </button>
                  </div>
                </FormGroup>

                <FormGroup label="Subdomain" error={touched.sub_domain && errors.sub_domain} requiredField>
                  <Form.Control
                    {...getFieldProps('sub_domain')}
                    type="text"
                  />
                </FormGroup>

                <FormGroup label="Group Name" error={touched.group_namenum && errors.group_namenum} requiredField>
                  <Form.Control
                    {...getFieldProps('group_namenum')}
                    type="text"
                  />
                </FormGroup>

                <FormGroup label="Membership Prefix" error={touched.membership_prefix && errors.membership_prefix} requiredField>
                  <Form.Control
                    {...getFieldProps('membership_prefix')}
                    type="text"
                  />
                </FormGroup>

                <FormControlLabel
                  control={
                    <Checkbox
                      name="is_white_labelled"
                      checked={values.is_white_labelled}
                      onChange={(e) => setFieldValue('is_white_labelled', e.target.checked)}
                      sx={{
                        '& .Mui-error': {
                          marginLeft: '0px',
                        }
                      }}
                    />
                  }
                  label="Is white label partner"
                />

                <ThemeLogo>
                  {values?.logo && typeof values?.logo !== "string" ? (
                    <Box
                      component="div"
                      sx={{ display: "flex", justifyContent: "center" }}
                    >
                      <img
                        style={{
                          maxWidth: "13vw",
                          cursor: "pointer",
                          borderRadius: "8px",
                        }}
                        src={URL.createObjectURL(values?.logo)}
                        alt="image1"
                        onMouseEnter={(e) => {
                          e.target.style.opacity = 0.8;
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.opacity = 1;
                        }}
                      />
                    </Box>
                  ) : values?.logo ? (
                    <Box
                      component="div"
                      sx={{ display: "flex", justifyContent: "center" }}
                    >
                      <img
                        style={{
                          maxWidth: "13vw",
                          cursor: "pointer",
                          borderRadius: "8px",
                        }}
                        src={values?.logo}
                        alt="image1"
                        onMouseEnter={(e) => {
                          e.target.style.opacity = 0.8;
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.opacity = 1;
                        }}
                      />
                    </Box>
                  ) : (
                    ""
                  )}
                  <Button variant="contained" component="label" fullWidth>
                    Upload Logo
                    <input 
                      type="file" 
                      name="logo" 
                      onChange={(event) => {
                        setFieldValue("logo", event.currentTarget.files[0]);
                      }}
                      hidden 
                    />
                  </Button>
                </ThemeLogo>
                {touched.logo && errors.logo && (
                  <p style={{ color: "#dc3545", fontSize: "12px", fontWeight: "400" }}>
                    {errors.logo}
                  </p>
                )}

                {errors.general && (
                  <p style={{ color: "#dc3545", fontSize: "12px", fontWeight: "400" }}>
                    {errors.general}
                  </p>
                )}

                <DialogActions>
                  <Button onClick={handleDialogClose} color="error">
                    Cancel
                  </Button>
                  <Button type="submit" color="primary" disabled={isSubmitting || saving}>
                    {isSubmitting || saving ? 'Submitting...' : 'Submit'}
                  </Button>
                </DialogActions>
              </form>
            )}
          </Formik>
        </DialogContent>
      </Dialog>

    </>
  );
}
const ThemeLogo = styled.div`
border: 1px solid #d1d5db;
width: 100%;
padding: 10px;
margin: 10px 12px;
border-radius: 10px;
background-color: #f2f2f2;
max-width: fit-content;
img {
  margin-bottom: 23px;
}
`;
const SelectBox = styled.select`
  width: 100%;
  height: 45px;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 10px;
  font-size: 16px;
  background: white;
  outline: none;
`;
const Top = styled.div`
  display: block;
  margin: auto;
  align-items: center;
  justify-content: center;
`;
const Image = styled.div`
display: flex;
justify-content: center;
  img {
    width: 219px;
    padding-bottom: 10px;
    @media (max-width: 1130px) {
      width: 180px;
    }
  }
`;

const Wrapper = styled.div`
  ${"" /* margin: 5px 0px 5px 5px; */}
  // padding: 10px;
  width: 330px;
  min-height: 100vh;
  // position: absolute;
  //display: grid;
  grid-template-rows: 1.5fr 10fr;
  background: rgb(252, 132, 51);
  position: sticky;
  top: 0;
  left: 0;
  @media (max-width: 1130px) {
    width: 330px;
  }
  @media (max-width: 890px) {
    display: none;
  }
`;

const MenuWrapper = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  gap: 5px 0px;
  // display: grid;
  // grid-template-rows: auto;
  text-align: center;
  padding: 20px 0px 0px 15px;
  ::-webkit-scrollbar {
    width: 7px;
  }
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
    border-radius: 5px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 6px #ffffff;
    background-color: rgb(252, 132, 51);
  }

  h1 {
    text-decoration: none;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    color: white;
    text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
    display: grid;
    align-items: center;
    justify-content: center;
  }
  a {
    text-decoration: none;
  }
  a.active h1 {
    color: black;
  }
  .active {
    height: 48px;
    // width: 267px;
    position: relative;
    background: #fff;
    border-radius: 20px 0px 0px 20px;
    text-align: center;
    display: grid;
    align-items: center;
    justify-content: center;
    padding: 5px;

    ::before,
    ::after {
      content: "";
      width: 20px;
      height: 20px;
      right: 0;
      position: absolute;
    }
    ::before {
      background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg"><path fill="white" fill-opacity="1" d="M0 0 Q20 0 20 20 L20 0Z" /></svg>');
      bottom: -20px;
    }
    ::after {
      background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg"><path fill="rgb(255, 255, 255)" d="M0 20 Q20 20 20 0 L20 20Z" /></svg>');
      top: -20px;
    }
  }
`;

const MenuItem = styled.div`
  width: 240px;
  color: rgba(255, 255, 255, 0.7);
  align-items: center;
  padding: 0px;
  transition: 0.5s ease-out;
  border-radius: 10px;
  justify-items: center;
  border: 1px solid transparent;
  border-radius: 50px;
  :hover {
    background: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(0, 0, 0);
    border-radius: 10px;
    padding: 0px 0px;
    color: black;
    transition-duration: 2s;
  }
`;
